// src/redux-store/reducers/loading.ts
import { LoadingState } from '../types/loading';
import { LOADING_START, LOADING_END } from '../types/loading';

const initialState: LoadingState = {
  isLoading: false,
  loadingCount: 0,
};

export function loadingReducer(state = initialState, action: any): LoadingState {
  switch (action.type) {
    case LOADING_START:
      return {
        ...state,
        loadingCount: state.loadingCount + 1,
        isLoading: true,
      };
    case LOADING_END:
      return {
        ...state,
        loadingCount: Math.max(0, state.loadingCount - 1),
        isLoading: Math.max(0, state.loadingCount - 1) > 0,
      };
    default:
      return state;
  }
}
